import React, { useReducer, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialButton from "../../components/MaterialButton";
import MaterialInput from "../../components/MaterialInput";
import MaterialBox from "../../components/MaterialBox";
import MaterialTypography from "../../components/MaterialTypography";

const ReusableFilter = ({
  open,
  onClose,
  onSave,
  title,
  data,
  dispatch,
  children,
}) => {
  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {/* Default Date Range Fields */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                From Date <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              type="date"
              name="fromDate"
              value={data?.fromDate}
              onChange={(e) => {
                const inputDate = e.target.value;
                const today = new Date().toISOString().split("T")[0];

                // Check if inputDate is not in the future
                if (inputDate <= today) {
                  dispatch({ value: inputDate, name: "fromDate" });
                }
                // Optionally, you can show an error or ignore invalid input
              }}
              inputProps={{
                max: new Date().toISOString().split("T")[0], // max today
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                To Date <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              type="date"
              name="toDate"
              value={data?.toDate}
              onChange={(e) => {
                const inputDate = e.target.value;
                const today = new Date().toISOString().split("T")[0];
                const minDate = data?.fromDate;

                // Allow only if toDate is between fromDate and today
                if (inputDate <= today && (!minDate || inputDate >= minDate)) {
                  dispatch({ value: inputDate, name: "toDate" });
                }
              }}
              inputProps={{
                max: new Date().toISOString().split("T")[0], // max today
                min: data.fromDate || undefined, // min fromDate
              }}
            />
          </Grid>

          {/* Custom Children */}
          {children}
        </Grid>
      </DialogContent>
      <DialogActions>
        <MaterialButton onClick={onClose}>Cancel</MaterialButton>
        <MaterialButton
          disabled={!data?.toDate || !data?.fromDate}
          onClick={handleSave}
          variant="gradient"
          color="dark"
        >
          Submit
        </MaterialButton>
      </DialogActions>
    </Dialog>
  );
};

export default ReusableFilter;
